import { createSelector } from 'reselect';
import { mapValues, orderBy, groupBy, compose, isEmpty, concat, some } from 'lodash/fp';
import { getStringProp } from '@mews/fp';
import { ApplicationState } from '@mews-commander/types';
import { mapId } from '@mews-commander/utils';
import { getOpenBillsByOwnerIds } from '../ducks/bills';
import { getOrderItemIdsByBillId } from '../ducks/orderItems';
import { getCurrentEnterprisePaymentIdsByBillId } from '../ducks/payments';
import { getCompanies } from '../ducks';

export const isCurrentEnterpriseBillEmpty = createSelector<
    ApplicationState,
    { billId: string },
    string[],
    string[],
    boolean
>(getCurrentEnterprisePaymentIdsByBillId, getOrderItemIdsByBillId, compose(isEmpty, concat));

export const getOrderedOpenBillIdsPerAccountIds = createSelector(
    getOpenBillsByOwnerIds,
    compose(mapValues(mapId), groupBy('ownerId'), orderBy(['isVirtual', 'createdUtc'], ['desc', 'desc']))
);

export const isAccountIdCompany = createSelector(getStringProp('accountId'), getCompanies, (accountId, companies) =>
    some({ id: accountId }, companies)
);
